import { Component, OnInit, ViewChild } from '@angular/core';
import { Utils } from 'src/app/utils/utils';
import { AppComponent } from 'src/app/app.component';
import { environment } from 'src/environments/environment';
import { CustomForms } from 'src/app/components/forms/custom-forms';
import { MainComponent } from 'src/app/components/main/main.component';
import { MapBounds, MapComponent, MapLatLng, MapMarker } from 'movisat-maps';
import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';
import { SsoService } from 'src/app/services/sso/sso.service';
import { CerraduraService } from 'src/app/services/cerraduras/cerradura.service';
import { CerraduraModel } from 'src/app/services/cerraduras/models/cerradura.model';
import { PosicionCerraduraModel } from 'src/app/services/cerraduras/models/posicionCerradura.model';
import { ElementoCerraduraModel } from 'src/app/services/cerraduras/models/elementoCerradura.model';
import { DateUtils } from 'src/app/utils/date-utils';
import * as xlsx from 'xlsx';


@Component({
  selector: 'app-listado-cerradura',
  templateUrl: './listado-cerradura.component.html',
  styleUrls: ['./listado-cerradura.component.css']
})
export class ListadoCerraduraComponent extends CustomForms implements OnInit {

  private componentRef = null;
  public static instance: ListadoCerraduraComponent = null; // Para controlar que sólo se cree una instancia
  public static numInstances = 0; // Para controlar el número de reproductores abiertos
  public theme = environment.tema;
  private subscriptionOnMarkerDragEnd; any = null;
  @ViewChild('form') form: jqxWindowComponent;
  @ViewChild('formDetalle') formDetalle: jqxWindowComponent;
  @ViewChild('myGrid') grid: jqxGridComponent;
  //  Esto es para que los textos en los controles del grid salgan en español
  public langGrid = JqWidgets.getLocalization('es');
  public dataSource: any;
  public dataAdapter: any;
  public cerraduras: CerraduraModel[] = [];
  public cerradura: CerraduraModel = new CerraduraModel();
  elemento: ElementoCerraduraModel = new ElementoCerraduraModel();
  private map: MapComponent;
  elementos: ElementoCerraduraModel[] = [];
  checkSelect: number[] = [];
  private empresaId: number = this.ssoService.getTicket().Empresa.IdGestion;
  editrow: number = 0;
  viewForm: boolean = false;
  clickTimer: any;
  mapWidth: number;
  mapHeight: number;


  constructor(private cerraduraService: CerraduraService, private ssoService: SsoService) {
    super();
    ListadoCerraduraComponent.instance = this;
  }
  public columns = [
    {
      width: 60,
      text: '',
      columntype: 'text',
      editable: false,
      datafield: 'Botones',
      groupable: false,
      menu: false,
      sortable: false,
      clickable: false,
      // quito el filtro de la columna
      filterable: false,
      renderer: (row: number, column: any, value: string): string => {
        return '<div style="text-align: center; margin-top: 5px;"><i style="font-size: 20px;" class="material-icons md-light">more_vert</i></div>';
      },
      createwidget: (
        row: any,
        column: any,
        value: string,
        htmlElement: HTMLElement
      ): void => {
        this.initBtnColumn(row, column, value, htmlElement);
      },
      initwidget: (
        row: any,
        column: any,
        value: string,
        htmlElement: HTMLElement
      ) => {
        this.initBtnColumn(row, column, value, htmlElement);
      },
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }], //agrego el total al grid
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="margin-left: 4px;">' + AppComponent.translate('Total') + ': ' +
            aggregates["Total"] + '</div>';
        }
        return renderstring;
      }
    },
    { text: AppComponent.translate('Id'), datafield: 'id', hidden: true, filtertype: 'textbox', editable: false, },
    { text: 'idElemento', datafield: 'elementoId', hidden: true, filtertype: 'textbox', width: 150, editable: false, },
    { text: AppComponent.translate('Tipo_producto'), datafield: 'tipoProducto', filtertype: 'checkedlist' },
    { text: AppComponent.translate('Ns_movisat'), width: 170, filtertype: 'textbox', datafield: 'nsMovisat', },
    { text: AppComponent.translate('Ns_fabricante'), width: 170, filtertype: 'textbox', datafield: 'nsFabricante', },
    { text: AppComponent.translate('Version'), filtertype: 'textbox', width: 100, datafield: 'version', },
    { text: AppComponent.translate('Imei'), filtertype: 'textbox', cellsalign: 'right', width: 170, datafield: 'imei', },
    { text: AppComponent.translate('Sim'), filtertype: 'textbox', cellsalign: 'right', width: 110, datafield: 'sim', },
    { text: 'IMSI', filtertype: 'textbox', width: 210, datafield: 'imsi', cellsrenderer: this.concatImsiRender },
    { text: 'MCC', filtertype: 'textbox', datafield: 'mcc', width: 1, hidden: true },
    { text: 'mnc', filtertype: 'textbox', datafield: 'mnc', width: 1, hidden: true },
    { text: 'ICC', filtertype: 'textbox', datafield: 'icc', width: 1, hidden: true },
    { text: AppComponent.translate('Nombre_elemento'), datafield: 'elemento', filtertype: 'textbox', width: 150 },
    { text: AppComponent.translate('Marca'), filtertype: 'checkedlist', datafield: 'marca', width: 110 },
    { text: AppComponent.translate('Modelo'), filtertype: 'checkedlist', datafield: 'modelo', width: 110 },
    { text: AppComponent.translate('Matricula'), filtertype: 'textbox', datafield: 'matricula', width: 110 },
    { text: AppComponent.translate('F_ult_conex'), datafield: 'fechaModificacion', columntype: 'datetimeinput', filtertype: 'date', width: 110 },
    { text: AppComponent.translate('Observaciones'), datafield: 'observaciones', menu: false, sortable: false, width: 110 },
  ];

  /**Inicializa el componente
*/
  init(componentRef: any) {
    // solo se puede crear una instancia
    if (ListadoCerraduraComponent.numInstances == 0) {
      ListadoCerraduraComponent.numInstances++;
      this.componentRef = componentRef;
    } else {
      componentRef.destroy();
    }
  }

  ngOnInit(): void {
    this.mapHeight = document.getElementById('map-container').offsetHeight;
    this.mapWidth = document.getElementById('map-container').offsetWidth;
    this.map = MainComponent.getInstance().getMap();
    this.getCerraraduras();
  }

  ngAfterViewInit(): void {
    this.addCustomForm(this.form);
    this.addCustomForm(this.formDetalle);
    this.form.setTitle(AppComponent.translate('Cerradura_lot'));
    this.formDetalle.setTitle(AppComponent.translate('Ficha_cerradura_iot'));
    this.onSubribeMap();

    //Utils.renderSizeGrid(this.grid, 500)
  }

  // Incializa la columna de iconos
  async initBtnColumn(
    row: any,
    column: any,
    value: string,
    htmlElement: HTMLElement
  ) {
    htmlElement.innerHTML = '';
    // Creo un contenedor para los botones
    const btnContainer = document.createElement('div');
    btnContainer.style.display = 'flex';
    btnContainer.style.gap = '2px';
    btnContainer.style.padding = '2px';

    let resolveData = async () => {
      if (row.boundindex) { return this.grid.getrowdata(row.boundindex) } else { return this.grid.getrowdata(row) }
    }

    let rowData = await resolveData();
    const btnInfo = document.createElement('div');
    btnInfo.innerHTML =
      '<button id=info style="height: 23px; width: 25px; padding: 0; margin: 0; cursor: pointer !important;">' +
      '<i style="font-size: 18px;" class="fas fa-circle-info"></i></button>';
    btnInfo.id = `buttonInfoMap_jqxButton`;
    btnContainer.appendChild(btnInfo);
    htmlElement.appendChild(btnContainer);

    // lo mismo para el resto de botones
    const newIconInfo = document.getElementById("buttonInfoMap_jqxButton");
    if (newIconInfo) {
      btnInfo.title = this.translate("Ficha_cerradura_iot");
    }

    // Capturo el click de los botones
    btnInfo.addEventListener('click', async (event: any) => {
      if (row.boundindex) {
        this.editrow = row.boundindex;
      } else {
        this.editrow = row;
      }
      let data = this.grid.getrowdata(this.editrow);
      this.cerradura = this.cerraduras.find((cerradura) => cerradura.id === data.id);
      this.cerradura.imsi = this.concatImsi(this.cerradura.mcc, this.cerradura.mnc, this.cerradura.icc);
      this.form.collapse();
      this.formDetalle.open(); //Abre el formulario
      this.formDetalle.bringToFront();
    });

    if (rowData?.elementoId) {

      const btnViewMap = document.createElement('div');
      btnViewMap.innerHTML =
        '<button id="viewMap" style=" height: 23px; width: 25px;  padding: 0; margin: 0; cursor: pointer !important;">' +
        '<i style="font-size: 18px;" class="fa-sharp fa-solid fa-location-dot"></i></button>';
      btnViewMap.id = `buttonViewMap_jqxButton`;
      btnContainer.appendChild(btnViewMap);

      const newIconViewMap = document.getElementById("buttonViewMap_jqxButton");
      if (newIconViewMap) {
        btnViewMap.title = this.translate("Posicionar_en_mapa");
      }

      btnViewMap.addEventListener('click', async (event: any) => {
        if (row.bounddata?.id !== undefined) {
          this.editrow = row.bounddata.id;
        } else {
          this.editrow = row;
        }
        let data = this.grid.getrowdata(this.editrow);
        this.cerradura = this.cerraduras.find((cerradura) => cerradura.id === data.id);
        this.onCentrar(data);
        this.form.collapsed(true);
      });
    }
  }

  renderRow(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    if (columnfield == 'fechaModificacion' || columnfield == 'fecha') {
      let date = new Date(value);
      return '<div style="margin-left: 4px; margin-top: 4px">' + DateUtils.formatDateTimeShort(date, true) + '</div>';
    } else {
      return '<div style="margin-left: 4px; margin-top: 4px">' + value + '</div>';
    }
  }

  onCloseForm(): void {
    this.cerradura = new CerraduraModel();
    this.form.expand();
    this.viewForm = false;
  }

  onRowdoubleclick(event: any): void {
    clearTimeout(this.clickTimer);  // Limpiamos el temporizador si se detecta un doble clic
    this.viewForm = true;
    let row: any = this.grid.getrowdatabyid(event.args.rowindex);
    this.cerradura = this.cerraduras.find(cerradura => cerradura.id === row.id);
    this.cerradura.imsi = this.concatImsi(this.cerradura.mcc, this.cerradura.mnc, this.cerradura.icc);
    this.form.collapse();
    this.formDetalle.open();
    setTimeout(() => {
    this.formDetalle.bringToFront();
    }, 100);
    
  }

  onCellClick(event: any) {
    clearTimeout(this.clickTimer);  // Siempre limpiamos el temporizador con cada clic para reiniciar el proceso
    // Configuramos el temporizador
    this.clickTimer = setTimeout(() => {
      if (event.args.datafield !== 'Botones') {
        this.editrow = event.args.rowindex;
        let row: any = this.grid.getrowdatabyid(event.args.rowindex);
        this.onCentrar(row);
        this.form.collapsed(true);
        this.viewForm = false;
        this.form.expand();
      }
    }, 500);  // 500 milisegundos de espera para determinar si es un clic individual
  }

  concatImsi(mcc: string, mnc: string, icc: string): string {
    let imsi: string = String(mcc) + String(mnc) + icc;
    // si alguno de los campos es null, devuelvo ese campo vacio
    if (mcc === null || mnc === null || icc === null) {
      if (mcc === null) {
        imsi = '-' + String(mnc) + String(icc);
        this.cerradura.mcc = '-';
      }
      if (mnc === null) {
        imsi = String(mcc) + '-' + String(icc);
        this.cerradura.mnc = '-';
      }
      if (icc === null) {
        imsi = String(mcc) + String(mnc) + '-';
        this.cerradura.icc = '-';
      }
    }
    return imsi;
  }

  // obtiene las cerraduras
  async getCerraraduras() {
    this.cerraduras = await this.cerraduraService.getCerraduras();
    if (this.cerraduras) {
      this.dataSource = {
        dataType: 'json',
        dataFields: [
          { name: 'Botones', type: 'string' },
          { name: 'id', type: 'number', map: 'id' },
          { name: 'elementoId', type: 'number', map: 'idElemento' },
          { name: 'tipoProducto', type: 'string', map: 'tipoOperacionStr' },
          { name: 'marca', type: 'string', map: 'elemento>marca' },
          { name: 'modelo', type: 'string', map: 'elemento>modelo' },
          { name: 'matricula', type: 'string', map: 'elemento>tag>matricula' },
          { name: 'elemento', type: 'string', map: 'elemento>nombre' },
          { name: 'nsMovisat', type: 'string', map: 'nsMovisat' },
          { name: 'nsFabricante', type: 'string', map: 'nsFabricante' },
          { name: 'version', type: 'string', map: 'versoft' },
          { name: 'imsi', type: 'string', map: 'imsi' },
          { name: 'imei', type: 'string', map: 'imei' },
          { name: 'sim', type: 'string', map: 'sim' },
          { name: 'icc', type: 'string', map: 'icc' },
          { name: 'mcc', type: 'string', map: 'mcc' },
          { name: 'mnc', type: 'string', map: 'mnc' },
          { name: 'fechaModificacion', type: 'string', map: 'fechaModificacionStr' },
          { name: 'observaciones', type: 'string', map: 'elemento>observaciones' },
        ],
        localdata: this.cerraduras
      }
      this.dataAdapter = new jqx.dataAdapter(this.dataSource);

    }
  }

  concatImsiRender(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    // concateno el icc, mcc, msi
    let imsi: string = String(rowdata.mcc) + String(rowdata.mnc) + rowdata.icc;
    // asigno imsi al campo imsi de la cerradura
    rowdata.imsi = imsi;
    // modifico para que salga con guiones y no null
    // si alguno de los campos es null, devuelvo ese campo vacio
    if (rowdata.mcc === null || rowdata.mnc === null || rowdata.icc === null) {
      if (rowdata.mcc === null) {
        imsi = '-' + String(rowdata.mnc) + String(rowdata.icc);
        rowdata.imsi = imsi
      }
      if (rowdata.mnc === null) {
        imsi = String(rowdata.mcc) + '-' + String(rowdata.icc);
        rowdata.imsi = imsi
      }
      if (rowdata.icc === null) {
        imsi = String(rowdata.mcc) + String(rowdata.mnc) + '-';
        rowdata.imsi = imsi
      }
    }

    return '<div style="margin-right: 4px; margin-top: 5px; text-align: right;">' + imsi + '</div>';

  }

  onCentrar(data: CerraduraModel) {
    if (data) {
      this.cerradura = this.cerraduras.find((cerradura) => cerradura.id === data.id);
      if (this.cerradura.elemento !== null) {
        this.map.setCenter(new MapLatLng(this.cerradura.elemento.lat, this.cerradura.elemento.lng));
        this.map.setZoom(20);
      } else {
        return MainComponent.getInstance().showError('ATENCION', 'No_existen_coordenadas', 2000);
      }
    }
  }

  async onSelect(event: any) {
    // Si se seleccionan todos los elementos del grid
    switch (event.args.rowindex.length) {
      case 0:
        this.checkSelect = [];
        break;
      default:
        let rows: any[] = this.grid.getrows();
        let idRow: number[] = this.grid.getselectedrowindexes();
        this.checkSelect = [];
        rows.forEach((element, index) => {
          if (idRow.includes(index)) {
            this.cerradura = this.cerraduras.find((cerradura) => cerradura.id === element.id);
            this.checkSelect.push(idRow[index]);
            this.elementos.push(this.cerradura.elemento);
          }
        });
        //this.checkSelect = Utils.onChangeArray(this.checkSelect);
        this.elementos = Utils.onChangeArray(this.elementos);
        break;
    }
  }

  onUnSelect(event) {
    let row: any = this.grid.getrowdatabyid(event.args.rowindex);
    // elimino el elemento deseleccionado del array checkSelect
    this.checkSelect.splice(this.checkSelect.indexOf(row), 1);
    this.checkSelect = Utils.onChangeArray(this.checkSelect);
    this.elementos.splice(this.elementos.indexOf(row.elemento), 1);
    this.elementos = Utils.onChangeArray(this.elementos);
  }

  onSubribeMap() {
    if (!this.subscriptionOnMarkerDragEnd) {
      this.subscriptionOnMarkerDragEnd = this.map.subscribeOnMarkerDragEnd(
        this,
        (_this: any, marker: MapMarker) => {
          if (
            MainComponent.getInstance().controlAmbitoActividad(
              marker.position
            )
          ) {
            this.elemento.lat = marker.position.lat;
            this.elemento.lng = marker.position.lng;
          } else {
            if (this.elemento.lat && this.elemento.lng) {
              MainComponent.getInstance().showError(
                'ATENCION',
                'Fuera_ambito',
                2000
              );
              marker.setPosition(
                new MapLatLng(this.elemento.lat, this.elemento.lng)
              );
            }
          }
        }
      );
    }
  }

  onPosicionar() {
    if (this.subscriptionOnMarkerDragEnd && this.elementos.length !== 0) {

      // Asgino los límites máximos y mínimos de latitud y longitud
      let minLat = this.elementos[0].lat;
      let maxLat = this.elementos[0].lat;
      let minLng = this.elementos[0].lng;
      let maxLng = this.elementos[0].lng;

      this.elementos.forEach((elemento) => {
        if (elemento.lat < minLat) minLat = elemento.lat;
        if (elemento.lat > maxLat) maxLat = elemento.lat;
        if (elemento.lng < minLng) minLng = elemento.lng;
        if (elemento.lng > maxLng) maxLng = elemento.lng;
      });

      // Creo objetos MapLatLng para las esquinas SW y NE
      const swCorner = new MapLatLng(minLat, minLng);
      const neCorner = new MapLatLng(maxLat, maxLng);

      // ajusto el mapa
      this.map.fitTo(new MapBounds(swCorner, neCorner));

      this.form.collapse();
    } else if (this.checkSelect.length === 0) {
      MainComponent.getInstance().showWarning('ATENCION', 'Seleccione_registro', 2000);
    } else {
      MainComponent.getInstance().showWarning('ATENCION', 'No_existen_coordenadas', 2000);
    }
  }

  // botones de acciones
  async onLocalizar() {
    let pedirPosicion: PosicionCerraduraModel = new PosicionCerraduraModel(this.checkSelect, this.empresaId);
    if (pedirPosicion && pedirPosicion.idsCerraduras.length !== 0) {
      let reult: any = await this.cerraduraService.pedirPosicion(pedirPosicion);
      if (reult.state == 'ok') {
        MainComponent.getInstance().showSuccess('ATENCION', 'Peticion_localizacion_realizada', 2000);
        this.grid.clearselection();
        this.checkSelect = [];
      }
    } else {
      MainComponent.getInstance().showError('ATENCION', 'Error_enviar_localizacion', 2000);
    }
  }

  onExportar() {
    if (this.grid.getrows().length === 0) {
      return MainComponent.getInstance().showWarning('ATENCION', this.translate('No_existen_datos'), 2000);
    } else {
      const json = this.grid.exportdata('json');
      let datos = JSON.parse(json);
      // Utiliza el array modificado en lugar del JSON original
      const ws: xlsx.WorkSheet = xlsx.utils.json_to_sheet(datos);
      this.generateAutofilterHeader(ws);
      const wb: xlsx.WorkBook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, 'Hoja1');
      xlsx.writeFile(wb, DateUtils.formatDateAMDhms(new Date()) + '_' + this.translate('Cerradura_lot') + '.xlsx');
    }
  }

  generateAutofilterHeader(sheet) {
    // Añade filtro a todas las casillas.
    sheet['!autofilter'] = { ref: sheet['!ref'] };
  }

  // Boton para imprimir
  onPrint() {
    if (this.grid.getrows().length === 0) {
      return MainComponent.getInstance().showWarning('ATENCION', this.translate('No_existen_datos'), 2000);
    } else {
      this.grid.hidecolumn('Botones');
      let gridContent = this.grid.exportdata('html');
      let newWindow = window.open('', '', 'width=800, height=500'),
        document = newWindow.document.open(),
        pageContent =
          '<!DOCTYPE html>\n' +
          '<html>\n' +
          '<head>\n' +
          '<meta charset="utf-8" />\n' +
          '<title>jQWidgets Grid</title>\n' +
          '</head>\n' +
          '<body>\n' +
          gridContent +
          '\n</body>\n</html>';
      this.grid.showcolumn('Botones');
      document.write(pageContent);
      document.close();
      newWindow.onafterprint = function () {
        newWindow.close();
      };
      newWindow.print();
    }
  }

  onClose() {
    if (this.componentRef) {
      this.componentRef.destroy();
      ListadoCerraduraComponent.numInstances--;
    }

    if (this.subscriptionOnMarkerDragEnd) {
      this.subscriptionOnMarkerDragEnd.unsubscribe();
      this.subscriptionOnMarkerDragEnd = null;
    }

    if (this.formDetalle) {
      this.formDetalle.destroy();
      this.viewForm = false;
    }
  }

  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }
}
